import React from "react";

const KS2Contributions = (props) => {
  const [selectedContribution, setSelectedContribution] = React.useState("3");
  const { setContributionSelection } = props;

  const handleContributionChange = e => {
    const { id, value } = e.target;
    setSelectedContribution(value);
    setContributionSelection({ name: id, value: "X" });
  }

  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 section-box">
          <div className="kr-title">
            <div className="form-check disabled">
              <input className="form-check-input" type="radio" disabled style={{ marginRight: "15px" }} />
              <label className="form-check-label pl-3 pr-4">Section C</label>
            </div>
          </div>
          <div className="personal-details">
            <span className="title pr-3">Contributions</span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
          <div className="mb-3 number">9.</div>
          <div className="details">
            <div className="form-group form-inline">
              <div className="col-md-4 section-label ">
                <label className="">Choose a contribution rate :</label>
              </div>
              <div className="col-md-8">
                <div className="section-form-group-inline pr-3">
                  <div className="d-flex align-items-center gap-3 flex-wrap">
                    {[3.5, 4, 6, 8, 10].map((value) => (
                      <div key={value} className="form-check form-check-inline mb-1 d-flex align-items-center">
                        <input
                          type="radio"
                          id={`contribution${value}`}
                          name="contribution"
                          value={value}
                          checked={selectedContribution === value.toString()}
                          onChange={handleContributionChange}
                          className="dash-textbox-coontribution form-check-input"
                        />
                        <label htmlFor={`contribution${value}`} className="form-check-label mb-0">{value}%</label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-12 mb-3 section-number-box">
              <label className="pl-4"> If you don’t choose a rate, the default rate of 3.5% will be deducted.</label>
        </div>
      </div>
    </React.Fragment>
  );
};

export default KS2Contributions;
